module.exports = __webpack_public_path__ + "img/powerImg2.5e324c75.jpg";